import axios from 'axios'
import { POS_ONLINE_HEADER } from '@/utils/static'

/**
 * Endpoint sinkronisasi turun katalog kasir (Mode Zero-Loading).
 * - /pos/products/changed?since=<unix>: delta produk (updated[] + deleted[] + synced_at).
 *   Tanpa `since` = full initial sync.
 * - /pos/priceRules: snapshot penuh price rule (tanpa delta).
 * Request latar belakang: tanpa toast error global & tanpa modal "tidak ada internet".
 */
const BACKGROUND_CONFIG = {
  ...POS_ONLINE_HEADER,
  skipErrorNotification: true,
  silentOffline: true,
}

export const getProductsChanged = (since) => {
  return axios.get('/pos/products/changed', {
    params: since ? { since } : undefined,
    ...BACKGROUND_CONFIG,
  })
}

export const getPosPriceRules = () => {
  return axios.get('/pos/priceRules', BACKGROUND_CONFIG)
}
